var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 16,
    fill: "#FEBF15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7914 18.6072C27.0355 18.398 27.1575 18.2933 27.2023 18.1688C27.2415 18.0596 27.2415 17.94 27.2023 17.8308C27.1575 17.7063 27.0355 17.6016 26.7914 17.3924L18.3206 10.1318C17.9004 9.77158 17.6903 9.59148 17.5124 9.58707C17.3578 9.58323 17.2101 9.65115 17.1124 9.77103C17 9.90897 17 10.1857 17 10.7392V15.0344C14.8653 15.4079 12.9116 16.4896 11.4597 18.1137C9.87682 19.8843 9.00123 22.1757 9 24.5508V25.1628C10.0493 23.8987 11.3595 22.8763 12.8408 22.1657C14.1467 21.5392 15.5584 21.1681 17 21.0703V25.2604C17 25.8139 17 26.0906 17.1124 26.2286C17.2101 26.3485 17.3578 26.4164 17.5124 26.4125C17.6903 26.4081 17.9004 26.228 18.3206 25.8678L26.7914 18.6072Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.b7f328bf03b58ac49b5255445fc0424b.svg";
export { ForwardRef as ReactComponent };